module.exports = __webpack_public_path__ + "static/media/icons_Bilan du Pied Bot (nourrisson).fde8252b.svg";